import { useRecoilValue } from "recoil";
import { createPortal } from "react-dom";
import { fetchState } from "@/comn/features/recoil";
import { Icon } from "../../components";

const LoadingIndicator = () => {
    const { requests } = useRecoilValue(fetchState);

    return (
        <>
            {Boolean(Object.keys(requests).length) &&
                createPortal(
                    <div className="fixed top-0 left-0 w-screen h-screen bg-black/10 z-[9999]">
                        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                            <Icon icon="loading" className="animate-spin" size="4xl" />
                        </div>
                    </div>,
                    document.body,
                )}
        </>
    );
};

export default LoadingIndicator;
